import Authenticator from '@/lib/Authenticator'
import jwtDecode from 'jwt-decode'
import http from '@/api/HttpHelper'

const auth = new Authenticator()

const state = {
    authenticated: !!localStorage.getItem('access_token'),
    accessToken: localStorage.getItem('access_token'),
    idToken: localStorage.getItem('id_token'),
    expiresAt: localStorage.getItem('expires_at'),
    showCookiePolicyInfo: false,
    passwordChangeRequired: false
}

const getters = {
    authenticated (state) {
        return state.authenticated
    },
    profile (state) {
        if (!state.idToken)
            return {}

        return jwtDecode(state.idToken)
    },
    isAdmin (state) {
        if (!state.idToken)
            return false
        
        return jwtDecode(state.idToken).isAdministrator
    },
    needsPasswordChange (state) {
        if (!state.idToken)
            return false

        return jwtDecode(state.idToken).app_metadata.must_change_password
    },
    isSkeidarRema (state) {
        if (!state.idToken)
            return false

        return jwtDecode(state.idToken).companyId === '876785769'
    },
    showCookiePolicyInfo (state) {
        return state.showCookiePolicyInfo
    },
    passwordChangeRequired (state) {
        return state.passwordChangeRequired
    }
}

const mutations = {
    authenticated (state, isAuthenticated) {
        state.authenticated = isAuthenticated
    },
    accessToken (state, accessToken) {
        state.accessToken = accessToken
        localStorage.setItem('access_token', accessToken)
    }, 
    idToken (state, idToken) {
        state.idToken = idToken
        localStorage.setItem('id_token', idToken)
    },
    expiresIn (state, expiresIn) {
        state.expiresAt = expiresIn
        localStorage.setItem('expires_at', expiresIn)
    }, 
    logout (state) {
        state.authenticated = false
        state.accessToken = null
        state.idToken = false

        localStorage.removeItem('access_token')
        localStorage.removeItem('id_token')
        localStorage.removeItem('expires_at')
    },
    showCookiePolicyInfo (state) {
        state.showCookiePolicyInfo = !state.showCookiePolicyInfo
    },
    passwordChangeRequired (state) {
        state.passwordChangeRequired = true
    }
}

const actions = {
    login () {
        auth.login()
    },
    logout ({ commit }) {
        commit('logout')
    },
    async changePassword ({ dispatch }, meta) {
        await http.put(`password/${meta.userId}`, {password: meta.password})
        dispatch('logout')
    },
    setAuthResult ({ commit, dispatch }, authResult) {
        const { accessToken, idToken, expiresIn } = authResult
        commit('accessToken', accessToken)
        commit('idToken', idToken)
        commit('expiresIn', expiresIn)
        commit('authenticated', true)
        dispatch('checkUserPasswordState')
    },
    setShowCookiePolicyInfo ({ commit }) {
        commit('showCookiePolicyInfo')
    },
    async forgotPassword (_, email) {
        const request = {
            email: email
        }
        await http.post('password/postResetPassword', request)
    },
    checkUserPasswordState ({ state, commit }) {
        if (!state.idToken)
            return
        
        if (jwtDecode(state.idToken).app_metadata.must_change_password) {
            commit('passwordChangeRequired')
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}